import axios from "axios";
import { Constants } from "../constants/Contants";
import { LocalStorageKeys } from "../constants/LocalStorageKeys";
import {getContext, getTimezone} from "./context";

const request = () => {
  let instance = axios.create({});
  instance.interceptors.request.use(async (config) => {
    var jwtToken = await localStorage.getItem('teleport_token');
    const hasExplicitAuthorization = Boolean(
      config.headers?.Authorization || config.headers?.get?.("Authorization")
    );
    if (!hasExplicitAuthorization) {
      config.headers.Authorization = jwtToken ? `${jwtToken}` : "";
    }
    config.headers.Origin = window.location.origin;
    config.baseURL = Constants.baseURL;

    config.withCredentials = true;

    const context = getContext();
    config.headers["X-Ctx-Client-Id"] = context.clientId;
    config.headers["X-Ctx-Client-Type"] = context.clientType;
    config.headers["X-Ctx-Currency"] = context.currency;
    config.headers["X-Ctx-Timezone"] = getTimezone();

    const t = Date.now();
    config.params = {
      ...config.params,
      t,
    };

    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if ([401, 403].includes(error?.response?.status)) {
        window.location.href = "/login";
      }
      return error.response;
    }
  );
  return instance;
};
export default request();
